import React, {useEffect, useState} from "react";
import {fetchPatientDetails} from "../../Clients/clientHelpers";
import {useSelector} from "react-redux";
import {toast} from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Input from "../../../../common/Input";
import {isEmpty, validateEmail} from "../../../../../_helpers/commonFunctions";
import axios from "axios";
import Alert from "react-bootstrap/Alert";

export const PatientDetailsModal = ({show, setShow, amka, successfullCallback, disabled}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const defaultPatientDetails = {
        amka: amka,
        address: "",
        postalCode: "",
        city: "",
        telephone: "",
        email: "",
    }
    const [patientDetails, setPatientDetails] = useState(defaultPatientDetails);

    const [fetching, setFetching] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            getPatientDetails();
        } else {
            setPatientDetails(defaultPatientDetails);
        }
    }, [show])

    const getPatientDetails = () => {
        setFetching(true);
        fetchPatientDetails(amka, company.id).then((res) => {
            if (res.success) {
                const patientData = res.data;
                setPatientDetails({
                    amka: amka,
                    address: patientData.address,
                    postalCode: patientData.postalCode,
                    city: patientData.city,
                    telephone: patientData.telephone,
                    email: patientData.email,
                })
            } else {
                setShow(false);
                toast.error("Σφάλμα κατά την άντληση ασθενή.");
            }
            setFetching(false);
        })
    }

    const postPatientDetails = () => {
        if (isEmpty(patientDetails.address)) {
            return toast.error("Παρακαλώ συμπληρώστε διεύθυνση.");
        } else if (isEmpty(patientDetails.city)) {
            return toast.error("Παρακαλώ συμπληρώστε πόλη.");
        } else if (isEmpty(patientDetails.postalCode)) {
            return toast.error("Παρακαλώ συμπληρώστε ταχ. κώδικα.");
        }
        if (!isEmpty(patientDetails.email)) {
            if (!validateEmail(patientDetails.email)) {
                return toast.error("Το e-mail δεν είναι δεκτό.");
            }
        }
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/update-patient-details`, {
            ...patientDetails,
            company: company.id,
        }, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής επεξεργασία στοιχείων.");
                setShow(false);
                if (typeof successfullCallback === "function" && res.data.data) successfullCallback(res.data.data);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            setLoading(false);
            toast.error("Σφάλμα κατά την απσστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Δεδομένα ασθενή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {disabled && (
                        <Alert variant={"secondary"} className={"mb-1"}>
                            Τα δεδομένα δεν είναι επεξεργάσιμα διότι βρίσκεστε σε ανοιχτή επίσκεψη.
                        </Alert>
                    )}
                    <Input
                        name={"patientDetails_amka"}
                        label={"ΑΜΚΑ"}
                        className={"mb-1"}
                        value={patientDetails.amka}
                        disabled={true}
                        autoComplete={"off"}
                    />
                    <Input
                        name={"patientDetails_address"}
                        label={"Διεύθυνση Οδός/Αριθμός"}
                        className={"mb-1"}
                        value={patientDetails.address}
                        onChange={(e) => setPatientDetails({...patientDetails, address: e.target.value})}
                        disabled={disabled}
                        autoComplete={"off"}
                    />
                    <Input
                        name={"patientDetails_city"}
                        label={"Πόλη"}
                        className={"mb-1"}
                        value={patientDetails.city}
                        onChange={(e) => setPatientDetails({...patientDetails, city: e.target.value})}
                        disabled={disabled}
                        autoComplete={"off"}
                    />
                    <Input
                        name={"patientDetails_postalCode"}
                        label={"Ταχ. Κώδικας"}
                        className={"mb-1"}
                        value={patientDetails.postalCode}
                        onChange={(e) => setPatientDetails({...patientDetails, postalCode: e.target.value})}
                        disabled={disabled}
                        autoComplete={"off"}
                    />
                    <Input
                        name={"patientDetails_telephone"}
                        label={"Τηλέφωνο"}
                        className={"mb-1"}
                        value={patientDetails.telephone}
                        onChange={(e) => setPatientDetails({...patientDetails, telephone: e.target.value})}
                        disabled={disabled}
                        autoComplete={"off"}
                    />
                    <Input
                        name={"patientDetails_email"}
                        label={"E-Mail"}
                        className={"mb-1"}
                        value={patientDetails.email}
                        onChange={(e) => setPatientDetails({...patientDetails, email: e.target.value})}
                        disabled={disabled}
                        autoComplete={"off"}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                        Κλείσιμο
                    </Button>
                    {!disabled && (
                        <Button variant="primary" onClick={() => postPatientDetails()} disabled={loading || fetching}>
                            Αποθήκευση
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default PatientDetailsModal
